import { render, staticRenderFns } from "./SubscriptionDetails.vue?vue&type=template&id=24304a00&scoped=true"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=js"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionDetails.vue?vue&type=style&index=0&id=24304a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24304a00",
  null
  
)

export default component.exports